import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isFinite } from 'lodash';
import { isDate } from 'date-fns';

export const validateYearRange = (minYear: number, maxYear: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control != null && control.value != null) {
      const error = { year: { message: `Year must be a valid number.` } };
      if (!isFinite(control.value) && !isDate(control.value)) {
        return error;
      }
      const year: number = isFinite(control.value) ? control.value : control.value.getFullYear();
      if (year < minYear || year > maxYear) {
        error.year.message = `Year must be between ${minYear} and ${maxYear}.`;
        return error;
      }
    }
    return null;
  };
};
